/* @flow */
import { toIdValue } from 'apollo-utilities';
import { dataIdFromObject } from '../memory';

export const reactionSummary = (_: *, args: *): string | void => {
  const dataId = dataIdFromObject({ __typename: 'ReactionSummary', messageUuid: args.messageUuid });
  return dataId ? toIdValue(dataId) : undefined;
};
